export default "__VITE_ASSET__C3pfu_sq__"